import { useI18n } from "utils/with-i18n.utils";

export const Calcul = () => {
  const i18n = useI18n();

  return (
    <div className="flex flex-col gap-6 items-center mb-[24px]">
      <div className="flex items-center p-2.5 w-fit bg-pastel-green-2">
        <span className="text-lg leading-[20.5px] text-black md:text-2xl">
          {i18n.t("environment.co2.since", {}, { html: true })}
        </span>
      </div>
      <div className="flex flex-col gap-3 items-center w-full text-center lg:flex-row lg:gap-[42px]">
        <section
          className="flex flex-col items-center py-8 w-full bg-white rounded-xl border-[1px] border-black"
          style={{ boxShadow: "4px 4px 0px 0px #000000" }}
        >
          <span className="text-[30px] font-black text-black md:text-[50px]">
            {i18n.t("environment.co2.firstValue", {}, { html: true })}
          </span>
          <span className="text-2xl text-black">
            {i18n.t("environment.co2.firstText")}
          </span>
        </section>
        <span className="text-[50px] font-normal">=</span>
        <section
          className="flex relative flex-col items-center py-8 w-full text-center bg-pastel-green-2 rounded-xl border-[1px] border-black"
          style={{ boxShadow: "4px 4px 0px 0px #000000" }}
        >
          <span
            className="text-[30px] font-black text-white md:text-[50px]"
            style={{
              textShadow:
                "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
            }}
          >
            {i18n.t("environment.co2.secondValue")}{" "}
            <span className="text-[18px] md:text-[29px]">
              {i18n.t("environment.co2.secondValueText", {}, { html: true })}
            </span>
          </span>
          <span className="text-2xl text-black">
            {i18n.t("environment.co2.secondText")}
          </span>
          <span className="absolute bottom-[-36px] w-full text-center">
            {i18n.t("environment.co2.asterisk")}
          </span>
        </section>
      </div>
    </div>
  );
};
